export default __webpack_public_path__ + "static/media/457.6abe8326.gif";